import { CHECK_REALTIME_SOCKET_CONNECTION } from 'actions/Types';

export const initialState = false;

function realtimeSocketConnected(state = initialState, action) {
  if (action.type === CHECK_REALTIME_SOCKET_CONNECTION) {
    const newState = action.payload;
    return newState;
  }

  return state;
}

export default realtimeSocketConnected;
